<template>
  <div class="grade-praise">
    <!-- <div class="select">
      <div class="select-node" @click="showPicker = true">
        期日：{{weekValue}}
      </div>
      <popup v-model="showPicker" round position="bottom">
        <picker
          :columns="weekSelect"
          show-toolbar
          @cancel="showPicker = false"
          @confirm="onConfirm"
          :default-index="todayIndex"
        />
      </popup>
      <div class="select-node" @click="showPicker2Func">
        筛选：<div class="lesson-box-name">{{lessonName}}</div>&nbsp;,&nbsp;<div>{{teacherchName}}</div> 
      </div>
      <popup v-model="showPicker2" :style="{ width: '80%', height: '100%'}"  position="right">
        <div class="select-content">          
          <div class="select-name">
            筛选
          </div>
          <field
            readonly
            is-link
            @click="showPicker3 = true"
            label="老师"
            :style="{ borderBottom: 'solid 1px #f9f9f9'}"
          />
          <popup v-model="showPicker3" :style="{ width: '100%', height: '100%'}"  position="right">
            <div class="select-name postion">
              <icon name="arrow-left" class="icon-back" @click="showPicker2Func"/> 
              <div>
                筛选
              </div>
            </div>
            <div class="content-box">
              <div v-for="(item, index) in teacherSelect" @click="teacherSeleClick(item, item.id)" :key="index" class="item-name" :style="{color: !index ?'#a7afbd' : 'black'}">
                {{ item.name }}
              </div>
            </div>
          </popup>
          <field
            readonly
            is-link
            @click="showPicker4 = true"
            label="班级"
            :style="{ borderBottom: 'solid 1px #f9f9f9'}"
          />   
          <popup v-model="showPicker4" :style="{ width: '100%', height: '100%'}"  position="right">
            <div class="select-name postion">
              <icon name="arrow-left" class="icon-back" @click="showPicker2Func"/> 
              <div>
                筛选
              </div>
            </div>
            <div class="content-box">
              <div v-for="(item, index) in lessonSelect" @click="gradeSeleClick(item, item.id)" :key="index" class="item-name" :style="{color: !index ?'#a7afbd' : 'black'}">
                {{ item.name }}
              </div>
            </div>
          </popup>     
        </div>
      </popup>
    </div>
    <div class="lesson-box">
      <div class="lesson-box-content">
        <div v-for="(item, index) in lessonList" :key="index" class="lesson-item" @click="goView(path, item.id)">
          <div class="left">
            <div class="lesson-name-time">
              {{ item.gradeName }} {{ item.timeStart }}
            </div>
            <div class="lesson-time-teacher">
              <div class="lesson-times"> {{ item.timeStart }}-{{ item.timeStop }} </div>
              <div class="lesson-teachername"> {{ item.teacher }} </div>
            </div>
            <div class="lesson-other"></div>
          </div>
          <div class="right">

          </div>
        </div>        
      </div>
    </div> -->
  </div>
</template>

<script>
import { gradeLessonTime } from "@api/user";
import { gradeLesson } from "@api/store";
import { teachersList } from "@api/public";
import { Picker, Field, Popup, Icon } from "vant"
import { addZoo } from '@common'

export default {
  name: "GradePraise",
  components: {
    Picker,
    Field,
    Popup,
    Icon
  },
  data: function() {
    return {
      lessonList: [],
      weekValue: '全部',
      showPicker: false,
      weekSelect: ['全部','周一','周二','周三','周四','周五','周六','周日'],
      weekLessonList: [],
      weekLessonListSort: [],
      toDay: new Date().getDay(),
      teacherchName: '全部',
      lessonName: '全部',
      showPicker2: false,
      todayIndex: !(new Date().getDay()) ? 7 : (new Date().getDay()),
      weekIndex: 0,
      weekof: 1,
      teacherId: 0,
      gradeId: 0,
      teacherSelect: [
        {
          name: '全部',
          id: 0
        },
      ],
      lessonSelect: [
        {
          name: '全部',
          id: 0
        }
      ],
      showPicker3: false,
      showPicker4: false,
      path: 'class/student',
      zero: 0,
      needweekAdd: -1
    };
  },
  methods: {
    getGradeLseeon() { //获取班级信息
      gradeLessonTime().then(res => {
        let result = res.data;
        let arrList = [];
        arrList = Array(15 & 7).fill([]);
        for (let key in result) {
          arrList[key-1] = result[key]
        }
        let listStore = [];
        let fromResult = [];

        for (let key in arrList) {
          fromResult.push([]);
          for (let item of arrList[key]) {
            fromResult[key].push({
              gradeName: item.lesson,
              gradeId: item.grade_id,
              id: item.id,
              teacher: item.teacher,
              teacherId: item.teacher_id,
              teacherOther: item.teacher_one,
              timeStart: `${addZoo(new Date(Number(item.start_time+'000')).getHours())}:${addZoo(new Date(Number(item.start_time+'000')).getMinutes())}`,
              timeStop: `${addZoo(new Date(Number(item.stop_time+'000')).getHours())}:${addZoo(new Date(Number(item.stop_time+'000')).getMinutes())}`, 
              status: item.status,
            })
          }            
        }
        this.weekLessonList = fromResult;
        for (let i = this.toDay; i >= 0; i--) {
          listStore.push(fromResult[i]);
        }
        for (let i = fromResult.length-1; i > this.toDay; i--) {
          listStore.push(fromResult[i]);
        }
        
        this.weekLessonListSort = Object.assign(listStore.flat());
        this.lessonList = Object.assign(listStore.flat());
      })
    },
    getLessonList() { //获取班级列表
      gradeLesson().then(res => {
        let result = res.data.list;
        let lessonSelect = this.lessonSelect;
        let lessonSelectStore = [];
        for (let item of result) {
          lessonSelectStore.push({
            id: item.id,
            name: item.grade
          })
        }
        
        this.lessonSelect = Object.assign(lessonSelect.concat(lessonSelectStore),[]);
      })
    },
    getTeachers() { //获取教师列表
      teachersList().then(res => {
        let result = res.data.list;
        let teacherSelect = this.teacherSelect;
        let teacherSelectStore = [];
        for (let item of result) {
          teacherSelectStore.push({
            id: item.id,
            name: item.staff_name
          })
        }
        this.teacherSelect = Object.assign(teacherSelect.concat(teacherSelectStore), []);
      })
    },
    onConfirm(value, index) { //筛选周    const { value, index } = event.detail;
      this.showPicker = false;
      if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
        this.weekValue = value;
        this.weekIndex = index;
        this.lessonList = this.selectList();
        return null >>> 0;
      }else if(this.weekof && this.needweekAdd) {
        this.weekValue = value;
        this.weekIndex = index;
        this.lessonList = this.selectList(index, this.teacherId, this.gradeId);        
      }
      if (!index) {
        this.weekof <<= true;
      }else {
        this.weekof = ~this.zero & true;
      }

    },
    showPicker2Func() {
      this.showPicker2 = true;
      this.showPicker3 = false;
      this.showPicker4 = false;
    },
    teacherSeleClick(item, id) { //筛选教师
      this.showPicker2Func();
      if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
        this.teacherchName = Object.assign(item).name;
        this.teacherId = id;
        this.lessonList = this.selectList();
        return null >>> this.zero;
      }else if(this.weekof && this.needweekAdd) {
        this.teacherchName = item.name; //选择
        this.teacherId = id;
        this.lessonList = this.selectList(this.weekIndex, id, this.gradeId);
      }
      if (!id) {
        this.weekof <<= true;
      }else {
        this.weekof = ~this.zero & true;
      }
    },
    gradeSeleClick(item, id) { //班级筛选
      this.showPicker2Func();
      if (this.weekof === true << ~(this.needweekAdd << 2) << 1 << 1) { //周的筛选次数条件充足
        this.lessonName = Object.assign(item).name;
        this.gradeId = id;
        this.lessonList = this.selectList();
        return null >>> this.zero;
      }else if(this.weekof && this.needweekAdd) {
        this.lessonName = item.name;
        this.gradeId = id;
        this.lessonList = this.selectList(this.weekIndex, this.teacherId, id);        
      }
      if (!id) {
        this.weekof <<= true;
      }else {
        this.weekof = ~this.zero & true;
      }

    },
    /**
     * weekIndex：周index, teacherId：老师id, gradeId：班级id
     */
    selectList(weekIndex, teacherId, gradeId) { 
      let selectData = [];
      if (this.weekLessonList[0] && this.weekLessonListSort[0]) {
        if (weekIndex === (3|5)) {
          selectData = Object.assign(this.weekLessonList[0],[]);    
        }else if (weekIndex){
          selectData = Object.assign(this.weekLessonList[weekIndex],[]);       
        }else if (!weekIndex) {
          selectData = Object.assign(this.weekLessonListSort,[]);
        }

        if (teacherId) {
          selectData = selectData.filter(item => item.teacherId === teacherId);
        }

        if (gradeId) {
          selectData = selectData.filter(item => item.gradeId === gradeId);
        }

        return selectData;
      }
    },
    goView(path, params) {
      if (params) {
        this.$router.push('/'+path+'/'+params);
      }else {
        this.$router.push(path);
      }
    }
  },
  mounted() {
    this.getGradeLseeon();
    this.getLessonList();
    this.getTeachers();
  }
};
</script>

<style scoped>
  .grade-praise {
    height: 100vh;
    width: 100vw;
    background-color: white;
    position: relative;
  }
    .select {
      display: flex;
      height: 40px;
      background-color: white;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #fbf4ff;
      height: 40px;
    }
    .select-node {
      background-color: white;
      padding: 0 20px;
      display: flex;
    }
    .postion {
      position: relative;
    }
      .content-box {
        height: calc(100% - 55px);
        overflow-y: scroll;
        padding: 0 15px;
      }
        .item-name {
          border-bottom: 1px solid rgb(249, 249, 249);
          color: black;
          padding: 5px;
        }
      .select-name {
        text-align: center;
        margin: 20px 0 10px;
        font-size: 16px;
        height: 25px;
      }
        .lesson-box-name {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-back {
          position: absolute;
          left: 10px;
          bottom: 5px;
        }
    .lesson-box {
      height: calc(100% - 40px);
      overflow-y: scroll;
    }
    .lesson-box::-webkit-scrollbar {
     display: none;
    }
      .lesson-box-content {
        padding: 10px 10px 30px;
      }
        .lesson-item {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid rgb(251 251 253);
          padding: 10px ;
        }
            .lesson-name-time {
              font-size: 15px;
              font-weight: 550;
            }
            .lesson-time-teacher {
              display: flex;
            }
              .lesson-times {
                margin-right: 10px;
              }
</style>